export default __webpack_public_path__ + "static/media/tenancy.1bab3d53.svg";